import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';

import { fetchTimeClocks, deleteTimeClock, updateSelectedStartDate, updateSelectedEndDate } from '../../store/actions/timeClock';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
import TimeClockDialog from '../../components/TimeClock/TimeClockDialog';
import Input from '../../components/Input/Input';

const styles = theme => ({
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px 0 ${theme.spacing(1)}px`,
  },
  loading: {
    display: 'flex',
  },
  date: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  inline: {
    margin: theme.spacing(1),
    display: 'inline-block',
  },
});

class TimeClocks extends React.Component {
  state = {
    openModal: false,
    currentItem: {
      id: 0,
      name: '',
    },
    tableRows: [],
  };

  componentDidMount() {
    if (this.props.selectedStartDate === null) {
      this.props.onUpdateSelectedStartDate(moment().format('YYYY-MM-01'));
      this.props.onUpdateSelectedEndDate(moment().format('YYYY-MM-DD'));
    }
    this.handleSearch();
  }

  componentWillReceiveProps(nextProps) {
    const {
      history, match, location, selectedStartDate, selectedEndDate,
    } = this.props;

    if (this.props.timeClocks !== nextProps.timeClocks) {
      const editAction = {
        name: 'Editar',
        icon: EditIcon,
        onClick: (item) => {
          this.setState({ openModal: true, currentItem: item });
        },
      };

      const createAction = {
        name: 'Cadastrar',
        icon: AddIcon,
        onClick: (item) => {
          history.push({
            pathname: `/pontos/${match.params.id}/cadastrar/${moment(item.name, 'LL - dddd').format('YYYY-MM-DD')}`,
            state: { name: location.state ? location.state.name : null },
          });
        },
      };

      const currentTimeClocks = [...nextProps.timeClocks];

      const momentStart = moment(selectedStartDate);
      const momentEnd = moment(selectedEndDate);
      const amountDays = momentEnd.diff(momentStart, 'days');

      const rows = [];
      for (let index = 0; index <= amountDays; index += 1) {
        if (
          currentTimeClocks.length &&
          currentTimeClocks[0].dtRef === momentStart.format('YYYY-MM-DD')
        ) {
          const timeClock = currentTimeClocks.shift();
          rows.push({
            id: index,
            dtRef: moment(timeClock.dtRef).format('LL - dddd'),
            objs: timeClock.objs,
            amount: timeClock.objs.length,
            actions: [editAction, createAction],
          });
        } else {
          rows.push({
            id: index,
            dtRef: momentStart.format('LL - dddd'),
            objs: [],
            amount: 0,
            actions: [createAction],
          });
        }
        momentStart.add(1, 'days');
      }

      this.setState({ tableRows: rows });
    }
  }

  handleInputChange = name => (event) => {
    if (name === 'startDate') {
      this.props.onUpdateSelectedStartDate(event.target ? event.target.value : event.format('YYYY-MM-DD'));
    } else if (name === 'endDate') {
      this.props.onUpdateSelectedEndDate(event.target ? event.target.value : event.format('YYYY-MM-DD'));
    } else {
      this.setState({ [name]: event.target ? event.target.value : event.format('YYYY-MM-DD') });
    }
  };

  handleSearch = () => {
    const params = {
      start: `${this.props.selectedStartDate || moment().format('YYYY-MM-01')} 00:00:00`,
      end: `${this.props.selectedEndDate || moment().format('YYYY-MM-DD')} 23:59:59`,
      employees: [this.props.match.params.id],
    };
    this.props.onFetchTimeClocks(params);
  };

  handleEditCancel = () => {
    this.setState({ openModal: false });
  };

  handleDelete = (data) => {
    this.props.onDeleteTimeClock(data);
  };

  render() {
    const {
      loading, classes, location, selectedStartDate, selectedEndDate,
    } = this.props;
    const {
      openModal, currentItem, tableRows,
    } = this.state;

    const employeeName = location.state ? location.state.name : null;

    const columns = [{ name: 'dtRef', label: 'Dia' }, { name: 'amount', label: 'Quantidade' }];

    return (
      <React.Fragment>
        <ContentHeader title="Registros de Ponto" subtitle="Listagem dos pontos do funcionário">
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSearch}
            disabled={!(selectedStartDate && selectedStartDate.length && selectedEndDate && selectedEndDate.length)}
          >
            <SearchIcon /> Buscar
          </Button>
        </ContentHeader>

        <Paper elevation={2}>
          <Grid container alignItems="baseline" className={classes.header}>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" color="textSecondary" className={classes.inline}>
                Funcionário:
              </Typography>
              <Typography variant="body1" className={classes.inline}>
                {employeeName}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} className={classes.date}>
              <Input
                elementType="datePicker"
                label="Início do período"
                value={selectedStartDate || moment().format('YYYY-MM-01')}
                onChange={this.handleInputChange('startDate')}
                margin="normal"
              />
              <Input
                elementType="datePicker"
                label="Fim do período"
                value={selectedEndDate || moment().format('YYYY-MM-DD')}
                onChange={this.handleInputChange('endDate')}
                margin="normal"
              />
            </Grid>
          </Grid>

          <DataTable rows={tableRows} columns={columns} loading={loading} independentActions />
        </Paper>

        <TimeClockDialog
          date={currentItem.name}
          timeClock={tableRows.length ? tableRows[currentItem.id].objs : []}
          handleDelete={this.handleDelete}
          open={openModal}
          onClose={this.handleEditCancel}
          loading={loading}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  timeClocks: state.timeClock.timeClocks,
  selectedStartDate: state.timeClock.selectedStartDate,
  selectedEndDate: state.timeClock.selectedEndDate,
});

const mapDispatchToProps = dispatch => ({
  onFetchTimeClocks: params => dispatch(fetchTimeClocks(params)),
  onDeleteTimeClock: data => dispatch(deleteTimeClock(data)),
  onUpdateSelectedStartDate: selectedStartDate => dispatch(updateSelectedStartDate(selectedStartDate)),
  onUpdateSelectedEndDate: selectedEndDate => dispatch(updateSelectedEndDate(selectedEndDate)),
});

TimeClocks.propTypes = {
  classes: PropTypes.object.isRequired,
  timeClocks: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onFetchTimeClocks: PropTypes.func.isRequired,
  onDeleteTimeClock: PropTypes.func.isRequired,
  onUpdateSelectedStartDate: PropTypes.func.isRequired,
  onUpdateSelectedEndDate: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(TimeClocks));
